import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Video, Linkedin } from 'lucide-react';
import { navigationLinks, socialLinks, companyInfo } from '../data/mock';

const Footer = () => {
  const getSocialIcon = (iconName) => {
    switch (iconName) {
      case 'instagram':
        return <Instagram size={16} />;
      case 'video':
        return <Video size={16} />;
      case 'linkedin':
        return <Linkedin size={16} />;
      default:
        return null;
    }
  };

  return (
    <footer className="bg-black border-t border-white/10 py-8 pl-2 pr-4 md:pl-8 md:pr-12 lg:pl-6 lg:pr-12">
      <div className="max-w-[1800px] mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Contact Info - Left Side */}
          <div className="flex flex-col items-start space-y-2">
            <p className="text-white text-lg font-spectral">Rajnagar Extension, Ghaziabad</p>
            <p className="text-white text-lg font-spectral">contact@brewingframes.com</p>
            <p className="text-white text-lg font-spectral">+91 9999198827</p>
            <Link to="/privacy-policy" className="text-white/60 hover:text-white transition-colors duration-300 text-lg font-spectral">Privacy Policy</Link>
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-6">
            {socialLinks.map((social) => (
              <a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/60 hover:text-white transition-colors duration-300"
                aria-label={social.name}
              >
                {getSocialIcon(social.icon)}
              </a>
            ))}
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-white/10 text-center">
          <p className="text-white/40 text-[10px] tracking-[0.2em]">
            © {new Date().getFullYear()} {companyInfo.name.toUpperCase()}. ALL RIGHTS RESERVED.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
